import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

interface FormLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

const FormLabel = forwardRef<HTMLLabelElement, FormLabelProps>(
  ({ className, children, required, ...props }, ref) => (
    <label ref={ref} className={cn('block text-sm font-medium text-gray-700', className)} {...props}>
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
  )
);
FormLabel.displayName = 'FormLabel';

export { FormLabel };
